import React from 'react'
import Header from '../components/Header'

const OrganizationOverviewPage = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default OrganizationOverviewPage
